import { Injectable } from '@angular/core';
import { ICashRegisterVendorInterface } from '../../cash-register-vendor.interface';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { LocalAppService } from '../../../../app/local-app.service';
import { CashRegisterEntity } from '../../../../../models/entity/cash-register/cash-register-entity';
import { NbasoftDeviceInfoResponse } from './model/info/nbasoft-device-info-response';
import { NbasoftDeviceInfoRequest } from './model/info/nbasoft-device-info-request';
import { CashRegisterCloseShiftLocalResponse } from '../../../../../models/rest/cash-register/close_shift/cash-register-close-shift-local-response';
import { CashRegisterXReportLocalResponse } from '../../../../../models/rest/cash-register/report/x-report/cash-register-x-report-local-response';
import { CashRegisterZReportBulkLocalResponse } from '../../../../../models/rest/cash-register/report/z-report/cash-register-z-report-bulk-local-response';
import { CashRegisterOpenShiftLocalResponse } from '../../../../../models/rest/cash-register/open_shift/cash-register-open-shift-local-response';

import { CashRegisterControlTapeLocalResponse } from '../../../../../models/rest/cash-register/control-tape/cash-register-control-tape-local-response';
import { StringUtils } from '../../../../../utils/string.utils';
import { CashRegisterPairLocalResponse } from '../../../../../models/rest/cash-register/pair/cash-register-pair-local-response';


@Injectable({
  providedIn: 'root'
})
export class NbasoftService implements ICashRegisterVendorInterface {

  private baseUrl: string = 'http://81.21.87.10:9842/api/v1';
  private token?: string;
  private cashRegisterId;
  appName = "NBASOFT";
  timeout: 30;

  constructor(private http: HttpClient,
    private localAppService: LocalAppService
  ) { }
  pair(cashRegister: CashRegisterEntity, data: CashRegisterPairLocalResponse) {
    throw new Error('Method not implemented.');
  }

  clearToken() {
    this.token = undefined;
    this.cashRegisterId = null;
  }

  setToken(cashRegister: CashRegisterEntity, token?: string) {
    this.token = token;
    this.cashRegisterId = cashRegister.id;
  }

  getToken(data: CashRegisterEntity) {
    return this.cashRegisterId == data.id ? this.token : null;
  }

  isLoggedIn(data: CashRegisterEntity): boolean {
    return StringUtils.isNotNull(this.token) && this.cashRegisterId == data.id;
  }

  setBaseUrl(data: CashRegisterEntity) {
    if (StringUtils.isEmpty(data.apiUrl)) {
      throw new Error("Yazar kasa ip adresi boş olamaz");
    }
    this.baseUrl = data.apiUrl!;

    if (!this.baseUrl.startsWith("http://")) {
      this.baseUrl = "http://" + this.baseUrl;
    }

    if (!this.baseUrl.endsWith("/api/v1")) {
      this.baseUrl = this.baseUrl + "/api/v1";
    }
  }

  async login(cashRegister: CashRegisterEntity, request: any) {
    this.setBaseUrl(cashRegister);

    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
    // 
    // this.setBaseUrl(cashRegister);

    // const deviceInfoResponse: NbasoftDeviceInfoResponseData = JSON.parse(cashRegister.deviceInfoData);

    // const requestData = new NbasoftLoginParameters();
    // requestData.role = cashRegister.userName;
    // requestData.pin = cashRegister.password;
    // requestData.cashregister_factory_number = deviceInfoResponse.cashbox_factory_number;

    // const request = new NbasoftLoginRequest();
    // request.parameters = requestData;
    // request.operationId = "toLogin";
    // request.version = 1;


    // const response = await firstValueFrom(
    //   this.localAppService.post(this.baseUrl!, JSON.stringify(request), { 'Content-Type': 'application/json' }, this.timeout)
    // );

    // 
    // const res: NbasoftLoginResponse = JSON.parse(response.data);

    // if (res.code !== 0) {
    //   throw new Error(this.appName + ':Login->' + res.code + res.message);
    // }

    // this.token = res.data.access_token;
  }

  async createSale(cashRegister: CashRegisterEntity, request: any) {

    this.setBaseUrl(cashRegister);

    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }

  async cancelSale(cashRegister: CashRegisterEntity, request: any) {
    this.setBaseUrl(cashRegister);
    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }
  async openShift(cashRegister: CashRegisterEntity, request: CashRegisterOpenShiftLocalResponse) {
    this.setBaseUrl(cashRegister);

    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }



  async closeShift(cashRegister: CashRegisterEntity, request: CashRegisterCloseShiftLocalResponse) {
    this.setBaseUrl(cashRegister);
    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data!, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }

  controlTape(cashRegister: CashRegisterEntity, request: CashRegisterControlTapeLocalResponse) {
    this.setBaseUrl(cashRegister);

    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl!, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }

  async getDeviceInfo(cashRegister: CashRegisterEntity) {
    let request = new NbasoftDeviceInfoRequest();
    request.operationId = "getInfo";
    request.version = 1;

    // `LocalAppService` post metodunu çağırma
    const response = await firstValueFrom(
      this.localAppService.post(this.baseUrl, JSON.stringify(request), { 'Content-Type': 'application/json' }, this.timeout)
    );

    // Yanıtı işleme
    const res: NbasoftDeviceInfoResponse = JSON.parse(response.data);

    if (res.code != 0) {
      throw new Error(this.appName + ":getInfo->" + res.code + res.message);
    }

    return res.data;
  }

  getXReport(cashRegister: CashRegisterEntity, request: CashRegisterXReportLocalResponse) {
    this.setBaseUrl(cashRegister);
    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl!, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }
  getZReport(cashRegister: CashRegisterEntity, request: CashRegisterZReportBulkLocalResponse) {
    this.setBaseUrl(cashRegister);
    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl!, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }

  private async handleRequest(
    cashRegister: CashRegisterEntity,
    request: any,
    action: () => Promise<any>
  ) {
    let oldToken = this.token;

    let response = await action();
    let res = JSON.parse(response.data);

    if (res.code === 0) {
      return res;
    }


    if (res.code === 401) {
      this.clearToken();
    }      // if (res.code === 401) {
    //   await this.login(cashRegister);
    //   request.data.replace(oldToken, this.token);
    //   response = await action();
    //   return JSON.parse(response.data);
    // }
    // else if (res.code === 503 || res.code === 504) {
    //   await this.openShift(cashRegister);
    //   request.data.replace(oldToken, this.token);
    //   await GeneralUtils.delay(2000);
    //   response = await action();
    //   return JSON.parse(response.data);
    // }

    return res;
  }
}
